import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import WhatWeDo from "@/components/WhatWeDo";
import Services from "@/components/Services";
import Stats from "@/components/Stats";
import About from "@/components/About";
import Flagship from "@/components/Flagship";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SplitLanding from "@/components/SplitLanding";
import IndustrialOverview from "@/components/IndustrialOverview";
import IndustrialPumps from "@/components/IndustrialPumps";
import HeadcorePage from "@/components/HeadcorePage";
import PageNavHelpers from "@/components/PageNavHelpers";
import { Toaster } from "@/components/ui/toaster";

const RegTech = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <WhatWeDo />
      <Services />
      <Stats />
      <About />
      <Flagship />
      <Contact />
      <Footer />
      <PageNavHelpers />
    </div>
  );
};

const Industrial = () => {
  return (
    <div className="min-h-screen bg-[#1a1a1a]">
      <Header />
      <IndustrialOverview />
      <Contact />
      <Footer />
      <PageNavHelpers />
    </div>
  );
};

const Pumps = () => {
  return (
    <div className="min-h-screen bg-[#1a1a1a]">
      <Header />
      <IndustrialPumps />
      <Contact />
      <Footer />
      <PageNavHelpers />
    </div>
  );
};

const Headcore = () => {
  return (
    <div className="min-h-screen bg-[#1a1a1a]">
      <Header />
      <HeadcorePage />
      <Contact />
      <Footer />
      <PageNavHelpers />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SplitLanding />} />
          <Route path="/regtech" element={<RegTech />} />
          <Route path="/industrial" element={<Industrial />} />
          <Route path="/industrial/pumps" element={<Pumps />} />
          <Route path="/industrial/headcore" element={<Headcore />} />
          {/* Backwards compatibility with earlier routes */}
          <Route path="/industrial/products" element={<Industrial />} />
          <Route path="/pumping" element={<Pumps />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
